







































import { Vue, Component, Model, Watch, Prop } from "vue-property-decorator";
import { VIPCompany, busy, db, VIPCompanyRequestStatus, VIPCompanyRest, IRestResult } from '@/loader';

var companiesLoaded = false;

@Component
export default class CompanySelect extends Vue {
	@Model("input", { default: null })
	public readonly value!: any;

	@Prop({ type: Boolean, default: false })
	public readonly multiple!: boolean;

	@Prop({ type: Boolean, default: false })
	public readonly canEdit!: boolean;

	@Prop({ type: Array, default: () => [] })
	public readonly include!: VIPCompany[];

	@Prop({ type: Array, default: () => [] })
	public readonly exclude!: VIPCompany[];

	@Prop({ type: Function, default: (option) => option.id })
	public readonly reduce!: Function;

	public get isBusy(): boolean {
		return busy.status;
	}

	public get companies(): VIPCompany[] {
		return db.companies.list
			.filter(c => (!this.include.length || this.include.includes(c)) && !this.exclude.includes(c))
			.sort((a, b) => a.name.toString().localeCompare(b.name.toString()));
	}

	public filter(options: VIPCompany[], search: string) {
		search = search.toLowerCase().removeDiacritics();
		return options.filter(option => option.toString().toLowerCase().removeDiacritics().includes(search));
	}

	public async created() {
		if (!companiesLoaded) {
			companiesLoaded = true;
			const per_page = 100;
			let result: IRestResult<VIPCompany> | null = null;
			let page = 1;
			do {
				result = await VIPCompanyRest.list({ page, per_page });
				if (result.success && result.total && Math.ceil(result.total / per_page) > page) {
					page++;
				} else  {
					break;
				}
			} while (result.success);
		}
	}
}
